import {
	trigger,
	transition,
	style,
	query,
	group,
	animateChild,
	animate
} from '@angular/animations';
import {RouteAnimationsEnum} from '../../projects/journal/src/_interface/route-animations.enum';
import {TRANSITION_ANIMATION_TIME} from 'shared/magic';

export const slideAnimation =
	trigger('routeAnimations', [
		transition(`${RouteAnimationsEnum.viewByAuthor} => ${RouteAnimationsEnum.viewByDate},
		${RouteAnimationsEnum.viewByAuthor} => ${RouteAnimationsEnum.viewByType},
		${RouteAnimationsEnum.viewByAuthor} => ${RouteAnimationsEnum.viewByList},
		${RouteAnimationsEnum.viewByDate} => ${RouteAnimationsEnum.viewByType},
		${RouteAnimationsEnum.viewByDate} => ${RouteAnimationsEnum.viewByList},
		${RouteAnimationsEnum.viewByType} => ${RouteAnimationsEnum.viewByList},
		${RouteAnimationsEnum.templates} => *`,
			[
			style({ position: 'relative' }),
			query(':enter, :leave', [
				style({
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					opacity: .5
				})
			], {optional: true}),
			query(':enter', [
				style({ left: '-100%', opacity: 0 })
			], {optional: true}),
			query(':leave', animateChild()),
			group([
				query(':leave', [
					animate(`${TRANSITION_ANIMATION_TIME} ease-out`, style({ left: '100%', opacity: .25 }))
				], {optional: true}),
				query(':enter', [
					animate(`${TRANSITION_ANIMATION_TIME} ease-out`, style({ left: '0%', opacity: .75 }))
				], {optional: true}),
			]),
		]),
		transition(`* <=> *`, [
			style({ position: 'relative' }),
			query(':enter, :leave', [
				style({
					position: 'absolute',
					top: 0,
					right: 0,
					width: '100%',
					opacity: .5
				})
			], {optional: true}),
			query(':enter', [
				style({ right: '-100%', opacity: 0 })
			], {optional: true}),
			query(':leave', animateChild(), {optional: true}),
			group([
				query(':leave', [
					animate(`${TRANSITION_ANIMATION_TIME} ease-out`, style({ right: '100%', opacity: .25 }))
				], {optional: true}),
				query(':enter', [
					animate(`${TRANSITION_ANIMATION_TIME} ease-out`, style({ right: '0', opacity: .75 }))
				], {optional: true}),
				query('@*', animateChild(), {optional: true})
			])
		])
	]);

export const fadeInAndOutAnimation =
	trigger('routeAnimations', [
		transition(`* <=> *`, [
			style({ position: 'relative' }),
			query(':enter, :leave', [
				style({
					display: 'block',
					position: 'absolute',
					top: '0%',
					left: '0%',
					width: '100%',
					opacity: .5
				})
			], {optional: true}),
			query(':enter', [
				style({ opacity: 0 })
			], {optional: true}),
			group([
				query(':leave', [
					animate(`${TRANSITION_ANIMATION_TIME} linear`, style({ opacity: .25 }))
				], {optional: true}),
				query(':enter', [
					animate(`${TRANSITION_ANIMATION_TIME} linear`, style({ opacity: .75 }))
				], {optional: true}),
				query('@*', animateChild(), { optional: true })
			])
		])
	]);
